import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import { Container, useMediaQuery, useTheme } from "@mui/material";
// import LinkIcon from "@mui/icons-material/Link";
import { initGA } from "./components/Tracking";
import { PopupModal } from "react-calendly";

import {
  // getTestimonials,
  getCommunity,
  getContact,
  getHome,
  getTeam,
  getLocation,
  getOfficeSpace,
  getEvents,
} from "./data";

//TODO add lazy loading and suspense
import MainNavigation from "./components/MainNavigation";
import MobileMenu from "./components/MobileMenu";
import Community from "./containers/Community";
import Contact from "./containers/Contact";
import Home from "./containers/Home";
import Team from "./containers/Team";
import Location from "./containers/Location";
import Events from "./containers/Events";
import OfficeSpace from "./containers/OfficeSpace";
import Footer from "./components/Footer";
import NoMatch from "./containers/NoMatch";
import Palette from "./Palette";
import "./App.css";

function App(props) {
  const theme = useTheme();
  const showTextNav = useMediaQuery(theme.breakpoints.up("lg"));

  // const [testimonialData, setTestimonialData] = useState([{}]);
  const [communityData, setCommunityData] = useState([{}]);
  const [contactData, setContactData] = useState([{}]);

  const [homeData, setHomeData] = useState([{}]);
  const [teamData, setTeamData] = useState([{}]);
  const [locationData, setLocationData] = useState([{}]);
  const [eventsData, setEventsData] = useState([{}]);
  const [officeSpaceData, setOfficeSpaceData] = useState([{}]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTouch, setIsTouch] = useState(false);
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    initGA("G-ZT099L6XR8");
  }, []);

  useEffect(() => {
    getHome(setHomeData, "kahanoff-home");
    getOfficeSpace(setOfficeSpaceData, "kahanoff-officespace");
    getCommunity(setCommunityData, "kahanoff-community");
    getContact(setContactData, "kahanoff-contact");
    getTeam(setTeamData, "kahanoff-team");
    getLocation(setLocationData, "kahanoff-location");
    // getTestimonials(setTestimonialData, "kahanoff-testimonials");
    getEvents(setEventsData, "kahanoff-events");
  }, []);

  const handleBookATourClick = () => {
    setIsModalOpen(true);
    scrollToTop();
    return true;
  };
  const handleOnTouchStart = event => {
    setIsTouch(true);
  };
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "auto" });
  };
  return (
    <Container className="App" maxWidth={"xl"} disableGutters onTouchStart={handleOnTouchStart}>
      {showTextNav && (
        <MainNavigation
          scrollToTop={scrollToTop}
          setIsModalOpen={setIsModalOpen}
          handleBookATourClick={handleBookATourClick}
          theme={theme}
        />
      )}
      {!showTextNav && (
        <MobileMenu scrollToTop={scrollToTop} handleBookATourClick={handleBookATourClick} />
      )}
      <Wrapper disableGutters maxWidth="xl">
        <Routes>
          <Route path="/" element={<Navigate replace to="home" />} />
          <Route
            path="home"
            element={
              <Home
                theme={theme}
                data={homeData}
                isLoading={!homeData?.createdAt}
                handleBookATourClick={handleBookATourClick}
              />
            }
          />

          <Route
            path="community"
            // element={
            //   typeof communityData.Hero === "object" && (
            //     <Community data={communityData} theme={theme} isSmall={isSmall} />
            //   )
            // }
            element={<Community data={communityData} theme={theme} isSmall={isSmall} />}
          />
          <Route
            path="team"
            element={<Team data={teamData} theme={theme} isSmall={isSmall} />}
            // element={
            //   typeof teamData.Hero === "object" && (
            //     <Team data={teamData} theme={theme} isSmall={isSmall} />
            //   )
            // }
          />
          <Route
            path="location"
            element={<Location data={locationData} theme={theme} isSmall={isSmall} />}
            // element={
            //   typeof teamData.Hero === "object" && (
            //     <Team data={teamData} theme={theme} isSmall={isSmall} />
            //   )
            // }
          />
          <Route
            path="office-space"
            element={<OfficeSpace data={officeSpaceData} theme={theme} isSmall={isSmall} />}
          />
          <Route path="contact" element={<Contact data={contactData} theme={theme} />} />
          <Route path="events" element={<Events data={eventsData} theme={theme} />} />
          <Route path="palette" element={<Palette data={communityData} />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>

        {/* <TriColor /> */}
        {/* <Registration theme={theme} /> */}
        <PopupModal
          url="https://calendly.com/kahanoffcentre"
          // pageSettings={this.props.pageSettings}
          // utm={this.props.utm}
          // prefill={this.props.prefill}
          onModalClose={() => setIsModalOpen(false)}
          open={isModalOpen}
          /*
           * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
           * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
           */
          rootElement={document.getElementById("root")}
        />
      </Wrapper>
      {homeData?.createdAt && <Footer />}
    </Container>
  );
}

const Wrapper = styled(Container)`
  margin-top: 59px;
  a:not(.button, .MuiButtonBase-root) {
    // color: inherit;
    font-weight: bold;
    &:hover {
      color: ${props => props.theme.palette.secondary.dark};
    }
    &:visited {
      color: ${props => props.theme.palette.secondary.main};
    }
  }

  ${props => props.theme.breakpoints.up("lg")} {
    margin-top: 88px;
  }
`;
export default App;
